/**
 * エプソンサンプルプログラムの証明書自動更新モード用
 * シリアルナンバーの変換ロジックをコピー
 * @see printer_sample.html
 */

function encodeBase32(byteArray): string {
  const bit5toBase32Dic = {
    '00000': 'A',
    '00001': 'B',
    '00010': 'C',
    '00011': 'D',
    '00100': 'E',
    '00101': 'F',
    '00110': 'G',
    '00111': 'H',
    '01000': 'I',
    '01001': 'J',
    '01010': 'K',
    '01011': 'L',
    '01100': 'M',
    '01101': 'N',
    '01110': 'O',
    '01111': 'P',
    '10000': 'Q',
    '10001': 'R',
    '10010': 'S',
    '10011': 'T',
    '10100': 'U',
    '10101': 'V',
    '10110': 'W',
    '10111': 'X',
    '11000': 'Y',
    '11001': 'Z',
    '11010': '2',
    '11011': '3',
    '11100': '4',
    '11101': '5',
    '11110': '6',
    '11111': '7',
  }
  let byteText = ''
  for (let i = 0; i < byteArray.length; i++) {
    byteText += String(Number(byteArray[i]).toString(2)).padStart(8, '0')
  }
  const bit5Array = byteText.match(/.{1,5}/g) || ''
  let base32Text = ''
  for (let i = 0; i < bit5Array.length; i++) {
    let bit5Text = bit5Array[i]
    if (bit5Text.length < 5) {
      bit5Text = bit5Text + '0'.repeat(5 - bit5Text.length)
    }
    if (bit5Text in bit5toBase32Dic) {
      base32Text += bit5toBase32Dic[bit5Text]
    }
  }
  return base32Text
}

export default async (serial: string): Promise<string> => {
  const epsonDomain = 'omnilinkcert.epson.biz'
  // Computes the SHA-256
  const buff = new Uint8Array([].map.call(serial, (c: string) => c.charCodeAt(0)) as number[]).buffer
  const hashHex = await crypto.subtle.digest('SHA-256', buff)
  // Encode the Base32
  const base32Text = encodeBase32(new Uint8Array(hashHex))
  return `${base32Text}.${epsonDomain}`
}
